import { HOOK_VARIATIONS_PER_PARENT } from "@nexus/contracts";

import type { PersonaScriptDto } from "@/features/persona-opportunities/api/persona-opportunity-scripts.api";

export function canShowAddThreeHooks(args: {
  canGenerateScripts: boolean;
  script: PersonaScriptDto;
  siblings: PersonaScriptDto[];
}): boolean {
  if (!args.canGenerateScripts) return false;
  if (args.script.status !== "READY") return false;
  if (args.script.parentScriptId) return false;
  if (args.siblings.some((sibling) => sibling.parentScriptId === args.script.id)) {
    return false;
  }
  return args.script.remainingFreeSlotCount >= HOOK_VARIATIONS_PER_PARENT;
}

export function shouldOpenHookVariationsPanel(
  correlationId: string,
  discardedCorrelationIds: ReadonlySet<string>,
): boolean {
  return !discardedCorrelationIds.has(correlationId);
}
